import React, { useMemo } from 'react'
import AsyncDropdown, { PropsWithAsyncDropdown } from 'core/elements/dropdown/AsyncDropdown'

interface Props {
  resourceTypes: string[]
}

export default function ResourceTypePicklist({
  name = 'resourceType',
  label = 'Resource Type',
  compact = false,
  resourceTypes = [],
  ...rest
}: PropsWithAsyncDropdown<Props>) {
  const options = useMemo(() => {
    return resourceTypes.map((type) => ({
      label: type,
      value: type,
    }))
  }, [resourceTypes])
  return <AsyncDropdown compact={compact} name={name} label={label} items={options} {...rest} />
}
